import { RootState } from "../store";

export const getGuestTenantId = (state: RootState): string =>
    state.guestTenantReducer.guestTenantId || "";
